/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './OpenFinanceBlog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function OpenFinanceBlog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="open-finance-blog">
        <ContainerHome24>
          <div className="is-mobi">
            <h2 className="open-finance-blog-titulo">Consulte nossos conteúdos</h2>
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`open-finance-blog-slide ${className}`}>
                    <a
                      href="blog/open-finance.html"
                      target="_blank"
                      className="open-finance-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-10/capa_2.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-10/capa_2.jpg" />
                        <img
                          src="static/amp/blog/post-10/capa_2.jpg"
                          alt="Vem ser open! Cadastre seus dados para conseguir taxas diferenciadas e ofertas personalizadas só para você!"
                        />
                      </picture>
                      <div className="open-finance-blog-card-textos">
                        <h3 className="open-finance-blog-slide-titulo">Open Finance</h3>
                        <p className="open-finance-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`open-finance-blog-slide ${className}`}>
                    <a
                      href="blog/conta-digital-santander.html"
                      target="_blank"
                      className="open-finance-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-16/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-16/capa.jpg" />
                        <img
                          src="static/amp/blog/post-16/capa.jpg"
                          alt="imagem de fundo vermelho com um celular e um cartão de crédito SX a direita."
                        />
                      </picture>
                      <div className="open-finance-blog-card-textos">
                        <h3 className="open-finance-blog-slide-titulo">
                          Abra sua conta digital com o Santander
                        </h3>
                        <p className="open-finance-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`open-finance-blog-slide ${className}`}>
                    <a
                      href="blog/o-que-saber-sobre-boleto-digital.html"
                      target="_blank"
                      className="open-finance-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-35/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-35/capa.jpg" />
                        <img
                          src="static/amp/blog/post-35/capa.jpg"
                          alt="casal realizando o pagamento do boleto de quitação"
                        />
                      </picture>
                      <div className="open-finance-blog-card-textos">
                        <h3 className="open-finance-blog-slide-titulo">
                          Boleto digital: o que saber sobre essa forma de pagamento
                        </h3>
                        <p className="open-finance-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            <h2 className="open-finance-blog-titulo">Consulte nossos conteúdos</h2>
            <div className="cards-desk">
              <a href="blog/open-finance.html" target="_blank" className="open-finance-blog-card">
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-10/capa_2.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-10/capa_2.jpg" />
                  <img
                    src="static/amp/blog/post-10/capa_2.jpg"
                    alt="Vem ser open! Cadastre seus dados para conseguir taxas diferenciadas e ofertas personalizadas só para você!"
                  />
                </picture>
                <div className="open-finance-blog-card-textos">
                  <h3 className="open-finance-blog-slide-titulo">Open Finance</h3>
                  <p className="open-finance-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/conta-digital-santander.html"
                target="_blank"
                className="open-finance-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-16/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-16/capa.jpg" />
                  <img
                    src="static/amp/blog/post-16/capa.jpg"
                    alt="imagem de fundo vermelho com um celular e um cartão de crédito SX a direita."
                  />
                </picture>
                <div className="open-finance-blog-card-textos">
                  <h3 className="open-finance-blog-slide-titulo">
                    Abra sua conta digital com o Santander
                  </h3>
                  <p className="open-finance-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/o-que-saber-sobre-boleto-digital.html"
                target="_blank"
                className="open-finance-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-35/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-35/capa.jpg" />
                  <img
                    src="static/amp/blog/post-35/capa.jpg"
                    alt="casal realizando o pagamento do boleto de quitação"
                  />
                </picture>
                <div className="open-finance-blog-card-textos">
                  <h3 className="open-finance-blog-slide-titulo">
                    Boleto digital: o que saber sobre essa forma de pagamento
                  </h3>
                  <p className="open-finance-blog-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default OpenFinanceBlog;
